import { CLIENT, CLIENT_ADMIN, CRUX_ADMIN, CRUX_OPERATOR, CRUX_STEWARD, DATA_ENGINEER } from './roles';

export const ACCESS_TOKEN = 'token_access';
export const REFRESH_TOKEN = 'token_refresh';

export const CRUX_ROLES = [CRUX_ADMIN, DATA_ENGINEER, CRUX_OPERATOR, CRUX_STEWARD];
export const ORG_ROLES = [CLIENT_ADMIN, CLIENT];

const TYPE_BACKFILL = 'backfill';
const TYPE_CATALOG = 'catalog';
const TYPE_CONNECTION = 'connection';
const TYPE_DATA_PRODUCT = 'data_product';
const TYPE_DATA_PRODUCT_SUBSCRIBER = 'data_product_subscriber';
const TYPE_DATA_PRODUCT_SUBSCRIPTION = 'data_product_subscription';
const TYPE_DATASET = 'dataset';
const TYPE_FRAME = 'frame';
const TYPE_HEALTH_DASHBOARD = 'health_dashboard';
const TYPE_NAVIGATOR = 'navigator';
const TYPE_NOTIFICATION = 'notification';
const TYPE_ORG = 'org';
const TYPE_PIPELINE = 'pipeline';
const TYPE_PLAN = 'plan';
const TYPE_STUDIO = 'studio';
const TYPE_USAGE = 'usage';
const TYPE_USER = 'user';
const TYPE_USERS = 'users';

const ACTION_ASSIGN_CRUX_ROLES = 'assign_crux_roles';
const ACTION_ASSIGN_ORG_ROLES = 'assign_org_roles';
const ACTION_CREATE = 'create';
const ACTION_CUSTOM_NORMALIZATION = 'custom_normalization';
const ACTION_DEACTIVATE = 'deactivate';
const ACTION_DELETE = 'delete';
const ACTION_DELETE_RESOURCE = 'delete_resource';
const ACTION_ENTITLE = 'entitle';
const ACTION_INTERNAL_DESTINATION = 'internal_destination';
const ACTION_MANAGE_CRUX_SETTINGS = 'manage_crux_settings';
const ACTION_NORMALIZERS = 'normalizers';
const ACTION_OVERRIDE = 'override';
const ACTION_RERUN_DELIVERY = 'rerun_delivery';
const ACTION_UPDATE = 'update';
const ACTION_UPDATE_API_KEY = 'update_api_key';
const ACTION_UPDATE_RESOURCE = 'update_resource';
const ACTION_VIEW = 'view';
const ACTION_VIEW_ALL = 'view_all';
const ACTION_VIEW_API_KEY = 'view_api_key';
const ACTION_VIEW_AS = 'view_as';
const ACTION_VIEW_EVERYTHING = 'view_everything';
const ACTION_VIEW_CADENCE_LOGS = 'view_cadence_logs';
const ACTION_VIEW_DEVELOPER_NOTES = 'view_developer_notes';
const ACTION_VIEW_SUPPLIER_DOCUMENTATION = 'view_supplier_documentation';

const TYPE_ACTION_SEPARATOR = ':';

const entitlement = (type, action) => `${type}${TYPE_ACTION_SEPARATOR}${action}`;

// when new types are introduced
// this object must be copied into the API as well
export const ENTITLEMENTS = {
  backfill: {
    create: entitlement(TYPE_BACKFILL, ACTION_CREATE),
    view: entitlement(TYPE_BACKFILL, ACTION_VIEW),
  },
  catalog: {
    view: entitlement(TYPE_CATALOG, ACTION_VIEW),
    viewAs: entitlement(TYPE_CATALOG, ACTION_VIEW_AS),
    viewEverything: entitlement(TYPE_CATALOG, ACTION_VIEW_EVERYTHING),
    viewSupplierDocumentation: (TYPE_CATALOG, ACTION_VIEW_SUPPLIER_DOCUMENTATION),
  },
  connection: {
    create: entitlement(TYPE_CONNECTION, ACTION_CREATE),
    delete: entitlement(TYPE_CONNECTION, ACTION_DELETE),
    update: entitlement(TYPE_CONNECTION, ACTION_UPDATE),
    view: entitlement(TYPE_CONNECTION, ACTION_VIEW),
    viewAll: entitlement(TYPE_CONNECTION, ACTION_VIEW_ALL),
  },
  dataProduct: {
    create: entitlement(TYPE_DATA_PRODUCT, ACTION_CREATE),
    customNormalization: entitlement(TYPE_DATA_PRODUCT, ACTION_CUSTOM_NORMALIZATION),
    deactivate: entitlement(TYPE_DATA_PRODUCT, ACTION_DEACTIVATE),
    delete: entitlement(TYPE_DATA_PRODUCT, ACTION_DELETE),
    deleteResource: entitlement(TYPE_DATA_PRODUCT, ACTION_DELETE_RESOURCE),
    entitle: entitlement(TYPE_DATA_PRODUCT, ACTION_ENTITLE),
    internalDestination: entitlement(TYPE_DATA_PRODUCT, ACTION_INTERNAL_DESTINATION),
    manageCruxSettings: entitlement(TYPE_DATA_PRODUCT, ACTION_MANAGE_CRUX_SETTINGS),
    normalizers: entitlement(TYPE_DATA_PRODUCT, ACTION_NORMALIZERS),
    override: entitlement(TYPE_DATA_PRODUCT, ACTION_OVERRIDE),
    update: entitlement(TYPE_DATA_PRODUCT, ACTION_UPDATE),
    updateResource: entitlement(TYPE_DATA_PRODUCT, ACTION_UPDATE_RESOURCE),
    view: entitlement(TYPE_DATA_PRODUCT, ACTION_VIEW),
    viewCadenceLogs: entitlement(TYPE_DATA_PRODUCT, ACTION_VIEW_CADENCE_LOGS),
  },
  dataProductSubscriber: {
    view: entitlement(TYPE_DATA_PRODUCT_SUBSCRIBER, ACTION_VIEW),
  },
  dataProductSubscription: {
    view: entitlement(TYPE_DATA_PRODUCT_SUBSCRIPTION, ACTION_VIEW),
  },
  dataset: {
    create: entitlement(TYPE_DATASET, ACTION_CREATE),
    delete: entitlement(TYPE_DATASET, ACTION_DELETE),
    update: entitlement(TYPE_DATASET, ACTION_UPDATE),
    viewDeveloperNotes: entitlement(TYPE_DATASET, ACTION_VIEW_DEVELOPER_NOTES),
  },
  frame: {
    create: entitlement(TYPE_FRAME, ACTION_CREATE),
    update: entitlement(TYPE_FRAME, ACTION_UPDATE),
  },
  healthDashboard: {
    rerunDelivery: entitlement(TYPE_HEALTH_DASHBOARD, ACTION_RERUN_DELIVERY),
    view: entitlement(TYPE_HEALTH_DASHBOARD, ACTION_VIEW),
  },
  navigator: {
    view: entitlement(TYPE_NAVIGATOR, ACTION_VIEW),
  },
  notification: {
    create: entitlement(TYPE_NOTIFICATION, ACTION_CREATE),
    delete: entitlement(TYPE_NOTIFICATION, ACTION_DELETE),
    update: entitlement(TYPE_NOTIFICATION, ACTION_UPDATE),
    view: entitlement(TYPE_NOTIFICATION, ACTION_VIEW),
  },
  org: {
    create: entitlement(TYPE_ORG, ACTION_CREATE),
    deactivate: entitlement(TYPE_ORG, ACTION_DEACTIVATE),
    update: entitlement(TYPE_ORG, ACTION_UPDATE),
    view: entitlement(TYPE_ORG, ACTION_VIEW),
    viewAll: entitlement(TYPE_ORG, ACTION_VIEW_ALL),
  },
  pipeline: {
    create: entitlement(TYPE_PIPELINE, ACTION_CREATE),
    view: entitlement(TYPE_PIPELINE, ACTION_VIEW),
  },
  plan: {
    view: entitlement(TYPE_PLAN, ACTION_VIEW),
  },
  studio: {
    view: entitlement(TYPE_STUDIO, ACTION_VIEW),
  },
  usage: {
    view: entitlement(TYPE_USAGE, ACTION_VIEW),
  },
  user: {
    assignCruxRoles: entitlement(TYPE_USER, ACTION_ASSIGN_CRUX_ROLES),
    assignOrgRoles: entitlement(TYPE_USER, ACTION_ASSIGN_ORG_ROLES),
    create: entitlement(TYPE_USER, ACTION_CREATE),
    delete: entitlement(TYPE_USER, ACTION_DELETE),
    update: entitlement(TYPE_USER, ACTION_UPDATE),
    updateApiKey: entitlement(TYPE_USER, ACTION_UPDATE_API_KEY),
    viewApiKey: entitlement(TYPE_USER, ACTION_VIEW_API_KEY),
  },
  users: {
    view: entitlement(TYPE_USERS, ACTION_VIEW),
  },
};

export const ENTITLEMENT_ROLES = {
  [CLIENT]: [ENTITLEMENTS.usage.view],
  [CLIENT_ADMIN]: [ENTITLEMENTS.usage.view, ENTITLEMENTS.user.assignOrgRoles],
  [CRUX_ADMIN]: [ENTITLEMENTS.usage.view, ENTITLEMENTS.user.assignCruxRoles, ENTITLEMENTS.user.assignOrgRoles],
  [CRUX_OPERATOR]: [ENTITLEMENTS.usage.view, ENTITLEMENTS.user.assignCruxRoles, ENTITLEMENTS.user.assignOrgRoles],
  [CRUX_STEWARD]: [ENTITLEMENTS.usage.view, ENTITLEMENTS.user.assignCruxRoles, ENTITLEMENTS.user.assignOrgRoles],
  [DATA_ENGINEER]: [ENTITLEMENTS.usage.view],
};

export const USER_SKELETON = {
  agreements: [],
  createdAt: '',
  email: '',
  entitlements: [],
  firstName: '',
  lastName: '',
  name: '',
  orgId: '',
  orgName: '',
  roles: [],
  showOnlyMyCatalogData: false,
  status: '',
  subscription: {
    endDate: 0,
    id: '',
    itemPriceId: '',
    plan: '',
    startDate: 0,
    status: '',
  },
  userId: '',
};
